export default __webpack_public_path__ + "static/media/FoxBusiness.94ac55f9.svg";